import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VSwitch from 'v-switch-case'

Vue.use(VSwitch)

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
